/**
 * Többszintes (nested) dropdown kezelés mobilon.
 *
 * A BS5 natív dropdown nem támogatja beépítve a nested dropdown menüket.
 * Ez a komponens mobil méret alatt (< 992px) átveszi az irányítást:
 *   - Szülő menüpontra kattintva kinyitja a gyermek menüt (nem navigál el)
 *   - Testvéreket bezárja
 *   - Doc-click bezár mindent
 *
 * Desktop-on (>= 992px) a CSS hover + :focus-within alapú dropdown dolgozik
 *  (lásd template-parts/components/navbar.scss).
 *
 * Akadálymentesség:
 *   - hover nélküli eszközön (pl. iPad landscape, >= 992px) is a click-toggle
 *     veszi át az irányítást, különben a szülő linkre tapintás elnavigálna
 *   - Escape bezárja a nyitott menüt és visszaadja a fókuszt
 *   - desktop fókusznál az aria-expanded szinkronban marad a :focus-within-nel
 *
 * A data-dc-dropdown="parent" attribútumot a Navwalker (PHP) injektálja
 * minden "menu-item-has-children" item-re.
 */
(function () {
  'use strict';

  var MOBILE_BP = 992;
  var toggles = document.querySelectorAll('[data-dc-dropdown="parent"]');
  if (!toggles.length) return;

  function isMobile() {
    // Szélesség VAGY hover-képtelen eszköz (touch) -- utóbbin a CSS :hover
    // megbízhatatlan, a click-toggle kell, különben az almenü elérhetetlen.
    return window.innerWidth < MOBILE_BP ||
      (window.matchMedia && window.matchMedia('(hover: none)').matches);
  }

  function closeSiblings(currentLi) {
    var parent = currentLi.parentElement;
    if (!parent) return;
    var siblings = parent.querySelectorAll(':scope > .dropdown.is-open');
    siblings.forEach(function (sib) {
      if (sib === currentLi) return;
      sib.classList.remove('is-open');
      sib.querySelectorAll('.dropdown.is-open').forEach(function (nested) {
        nested.classList.remove('is-open');
        var nm = nested.querySelector(':scope > .dropdown-menu');
        if (nm) nm.classList.remove('show');
        var nt = nested.querySelector(':scope > [data-dc-dropdown]');
        if (nt) nt.setAttribute('aria-expanded', 'false');
      });
      var sm = sib.querySelector(':scope > .dropdown-menu');
      if (sm) sm.classList.remove('show');
      var st = sib.querySelector(':scope > [data-dc-dropdown]');
      if (st) st.setAttribute('aria-expanded', 'false');
    });
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      if (!isMobile()) return;

      var li = toggle.closest('.dropdown');
      var menu = li ? li.querySelector(':scope > .dropdown-menu') : null;
      if (!li || !menu) return;

      var isOpen = li.classList.contains('is-open');

      if (isOpen) {
        // Második kattintás → engedd a navigációt (ha van href)
        return;
      }

      e.preventDefault();
      closeSiblings(li);
      li.classList.add('is-open');
      menu.classList.add('show');
      toggle.setAttribute('aria-expanded', 'true');
    });
  });

  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    if (!e.target.closest('.dropdown')) {
      closeAllOpen();
    }
  });

  function closeAllOpen() {
    document.querySelectorAll('.dropdown.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      var m = d.querySelector(':scope > .dropdown-menu');
      if (m) m.classList.remove('show');
      var t = d.querySelector(':scope > [data-dc-dropdown]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  // Escape: nyitott menü bezárása + fókusz vissza a szülő menüpontra (WCAG).
  // Desktopon a :focus-within addig tartaná nyitva a menüt, amíg a fókusz a
  // li-n belül van -- ezért a bezárást a .drew-esc-closed class kényszeríti ki
  // (navbar.scss: display:none !important), a fókusz pedig a togglera kerül,
  // így a felhasználó nem veszti el a helyét. A class fókusz-elhagyáskor vagy
  // egér-belépéskor lekerül, a menü utána normálisan újranyitható.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    var active = document.activeElement;
    var li = active ? active.closest('.dropdown') : null;

    closeAllOpen(); // mobil .is-open/.show állapotok

    if (!li) return;

    // A legkülső dropdown li-t zárjuk (nested almenüből is a fő menüpontra lépünk)
    var rootLi = li;
    while (rootLi.parentElement && rootLi.parentElement.closest('.dropdown')) {
      rootLi = rootLi.parentElement.closest('.dropdown');
    }

    rootLi.classList.add('drew-esc-closed');
    rootLi.querySelectorAll('.dropdown').forEach(function (nested) {
      nested.classList.add('drew-esc-closed');
    });

    var toggle = rootLi.querySelector(':scope > [data-dc-dropdown], :scope > a');
    if (toggle) {
      toggle.focus();
      toggle.setAttribute('aria-expanded', 'false');
    }
  });

  function clearEscClosed(li) {
    li.classList.remove('drew-esc-closed');
    li.querySelectorAll('.drew-esc-closed').forEach(function (n) {
      n.classList.remove('drew-esc-closed');
    });
  }

  // Desktop: aria-expanded szinkron a :focus-within-nel (a CSS nyitja a menüt,
  // de a felolvasó az aria-expanded-ből tudja meg, hogy nyitva van)
  document.querySelectorAll('.navbar .dropdown').forEach(function (li) {
    var toggle = li.querySelector(':scope > [data-dc-dropdown]');
    if (!toggle) return;

    li.addEventListener('focusin', function () {
      // Escape utáni állapotban a menü zárva van -- az aria maradjon false
      if (!isMobile() && !li.classList.contains('drew-esc-closed')) {
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
    li.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !li.contains(e.relatedTarget)) {
        clearEscClosed(li); // a fókusz elhagyta a menüpontot → reset
        if (!isMobile()) toggle.setAttribute('aria-expanded', 'false');
      }
    });
    li.addEventListener('mouseenter', function () {
      clearEscClosed(li); // egeres újranyitás Escape után
    });
  });
})();
